// https://github.com/streamich/react-use is no longer actively maintained but it's the best we've got right now.
// TODO: Switch to a maintained library.
// This files fixes a few issues with `useMeasure`:
//  1. `UseMeasureRef` doesn't accept `null`, even though the `ref` prop requires it.
//  2. `useMeasure` doesn't handle `null`.
//     If an element is removed from the DOM, `useMeasure` continues to report the last measurements.
import { useCallback, useState } from 'react';
import { useMeasure as useMeasure_ } from 'react-use';
import { UseMeasureRect } from 'react-use/lib/useMeasure';

const RECT0: UseMeasureRect = {
  x: 0,
  y: 0,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  height: 0,
  width: 0,
};

// Issue 1: Added `| null` to the element arg.
export type UseMeasureRef<E extends HTMLElement = HTMLElement> = (element: E | null) => void;

export type UseMeasureResult<E extends HTMLElement = HTMLElement> = [
  UseMeasureRef<E>,
  UseMeasureRect,
];

/**
 * A wrapper around `useMeasure` that handles null elements.
 * @returns A tuple of [ref, rect].
 */
export function useMeasure<E extends HTMLElement = HTMLElement>(): UseMeasureResult<E> {
  const [ref, rect] = useMeasure_();

  // Issue 2: Handle null case and return zero sized rect.
  const [isNull, setIsNull] = useState(true);
  const wrappedRef = useCallback(
    (element: E | null) => {
      if (element === null) {
        setIsNull(true);
      } else {
        setIsNull(false);
        ref(element);
      }
    },
    [ref],
  );
  return [wrappedRef, isNull ? RECT0 : rect];
}
